__webpack_require__.p = "https://assets.khanoumi.com/4.190.1.0/_next/";